import React, { useEffect, useRef, useState } from "react";

const CountUp = ({ value, decimals = 0, suffix = "", prefix = "" }) => {
  const ref = useRef(null);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let raf = 0;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        const start = performance.now();
        const dur = 1300;
        const step = (now) => {
          const t = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - t, 3);
          setDisplay(value * eased);
          if (t < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => {
      io.disconnect();
      cancelAnimationFrame(raf);
    };
  }, [value]);

  return (
    <span ref={ref} style={{ fontVariantNumeric: "tabular-nums" }}>
      {prefix}
      {display.toFixed(decimals)}
      <span className="text-blue-600">{suffix}</span>
    </span>
  );
};

const STATS = [
  { value: 99.9, decimals: 1, suffix: "%", en: "Uptime across the platform", ar: "وقت تشغيل عبر المنصة" },
  { value: 15, suffix: " min", en: "From signup to live bookings", ar: "من التسجيل إلى الحجوزات المباشرة" },
  { value: 3, suffix: "%", en: "Our fee — only when you get paid", ar: "رسومنا — فقط عندما تُدفع لك" },
  { value: 24, suffix: "/7", en: "Bookings captured while you sleep", ar: "حجوزات تُلتقط وأنت نائم" },
];

export const StatsSection = ({ isAr }) => (
  <section className="py-16 sm:py-20 bg-white" data-testid="supplier-stats-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10" dir={isAr ? "rtl" : undefined}>
        {STATS.map((s, i) => (
          <div key={i} className="text-center lg:text-left" data-testid={`supplier-stat-${i}`}>
            <div className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900 mb-2">
              <CountUp value={s.value} decimals={s.decimals || 0} suffix={s.suffix} />
            </div>
            <p className="text-sm text-gray-500 leading-snug">{isAr ? s.ar : s.en}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
